import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

/**
 * Mobile / fullscreen variant of the modal box (used inside `<Modal.Responsive>` on small screens).
 */
export const responsiveModalBoxMobile = css`
  width: 100%;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  overflow: auto;
  border-radius: ${theme.borderRadius.medium};
  border-bottom-left-radius: 0;
  border-bottom-right-radius: 0;

  :focus {
    outline: none;
  }

  .wv-modal-header {
    padding: ${theme.spacing(2, 3)};
  }

  .wv-modal-footer {
    padding: ${theme.spacing(2, 3)};
  }
`;

/**
 * Outer body wrapper when in responsive (mobile) mode. The `--responsive-modal-top-offset` CSS variable
 * carries the runtime `topOffset`.
 */
export const responsiveModalBodyResponsive = css`
  width: 100%;
  height: calc(100% - var(--responsive-modal-top-offset, 0px));
  position: absolute;
  top: var(--responsive-modal-top-offset, 0px);
  left: 0;
  z-index: ${theme.zIndex.modals};
`;
